export default "__VITE_ASSET__urc5Ihdv__"